import { render, staticRenderFns } from "./Company-editor.vue?vue&type=template&id=58547a62&"
import script from "./Company-editor.vue?vue&type=script&lang=js&"
export * from "./Company-editor.vue?vue&type=script&lang=js&"
import style0 from "./Company-editor.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports